<template>
  <main class="dashboard assistance-form">
    <div class="container-fluid container-fluid--max">
      <notification>
        <router-link :to="{ name: 'productRegistrationForm', params: { id: 'new' } }">Enregistrer un nouveau produit</router-link>
      </notification>
      <div class="card">
        <div class="card-body">
          <router-link :to="{ name: 'supportRequests' }" tag="a" class="back btn btn-link uppercase smaller pl-0">
            <i class="back__icon fa fa-close mr-h" aria-hidden="true"></i>Retour
          </router-link>
          <section class="dash-assist-form px-lg-5 mt-4">
            <h1 class="dashboard__title heading-secondary">Nouvelle demande d'assistance</h1>
            <form class="mt-4" @submit.prevent="submit">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-5">
                  <div class="form-group">
                    <label class="access-form__label">Quel produit ?</label>
                    <v-select :options="options"
                      :reduce="pr => pr.id"
                      label="name"
                      :searchable="false"
                      :clearable="false"
                      :disabled="disabled"
                      v-model="params.product_registration_id"
                      :class="{ 'is-error': errors.product_registration_id }">
                    </v-select>
                    <small class="text-danger">{{ errors.product_registration_id }}</small>
                  </div>
                </div>
                <div class="form-group col-12 col-sm-6 ml-sm-auto">
                  <label class="access-form__label">Photos supplémentaires</label>
                  <div class="grid1x1">
                    <div class="grid1x1__item--4x">
                      <label class="image-upload grid1x1__item-inner" for="imageUpload" :class="{ 'disabled': !enableUpload || disabled }">
                        <i class="image-upload__icon-camera fa fa-camera"><i class="image-upload__icon-plus fa fa-plus"></i></i>
                        <input type="file" class="form-control-file d-none" id="imageUpload" ref="imgUpload" @change="setImage" :disabled="!enableUpload || disabled">
                      </label>
                    </div>
                    <div class="grid1x1__item--4x" v-for="(image, i) in images" :key="'image-' + i">
                      <div class="grid1x1__item-inner">
                        <img class="grid1x1__img" :alt="image.filename" :src="image.preview">
                      </div>
                      <button type="button" class="image-upload__close btn btn-sm smaller p-1" :class="'btn-' + $mainColor" @click="removeImage(i)">
                        <i class="fa fa-close" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <small class="text-danger mt-1">{{ imageError }}</small>
                </div>
              </div>
              <div class="form-row">
                <d-input v-model="params.last_sweeping_at" label="Date du dernier ramonage" :disabled="disabled" class="col" />
                <d-input v-model="params.last_maintenance_at" label="Date du dernier entretien" :disabled="disabled" class="col" />
              </div>
              <div class="form-group">
                <label class="access-form__label">Description du problème</label>
                <textarea class="access-form__textarea form-control" v-model="params.problem_description" required :disabled="disabled"></textarea>
              </div>
              <div class="form-group custom-control custom-checkbox">
                <input type="checkbox" id="confirmation" class="custom-control-input" v-model="params.certify_data" required :disabled="disabled">
                <label for="confirmation" class="custom-control-label text-secondary">
                  Je certifie exactes toutes les informations ci-dessus
                  <abbr title="Ce champ est obligatoire">*</abbr>
                </label>
                <div><small class="text-danger bold">{{ errors.certify_data }}</small></div>
              </div>
              <p class="small text-secondary thin">
                Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par {{ $root.savTitle }} pour la gestion du service après-vente. Elles sont conservées pendant 5 ans et sont destinées à {{ $root.savTitle }}. Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en nous <router-link :to="{ name: 'clientContact' }" tag="a" class="btn-link">contactant par email</router-link>.
              </p>
              <s-button :css-class="'uppercase btn-block btn-outline-' + $mainColor" :loading="loading" @submit="submit" :disabled="disabled">
                Envoyer ma demande d'assistance
              </s-button>
            </form>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'SupportRequestForm',
  data () {
    return {
      loading: false,
      disabled: false,
      params: {
        certify_data: false
      },
      errors: {},
      options: [],
      images: []
    }
  },
  computed: {
    ...mapState(['currentClient', 'clientAuth']),
    ...mapGetters({ productRegistrations: `${store.$appName}/productRegistrations` }),
    imgCount () {
      if (this.images.length === 1) return 'one'
      if (this.images.length === 2) return 'two'
      else return 'three'
    },
    enableUpload () {
      return this.images.length < 3
    },
    imageError () {
      let error
      ['one', 'two', 'three'].filter(img => {
        if (this.errors[`installation_picture_${img}`]) error = this.errors[`installation_picture_${img}`]
      })
      return error
    }
  },
  mounted () {
    if (_.isEmpty(this.productRegistrations)) {
      this.disabled = true
    } else {
      this.options = this.productRegistrations.map(pr => {
        return {
          id: pr.id,
          name: pr.product.name
        }
      })
      this.params.product_registration_id = this.$route.query.id ? this.$route.query.id : _.first(this.productRegistrations).id
    }
  },
  methods: {
    setImageParam () {
      _.each(this.images, (img, idx) => {
        this.params[`installation_picture_${this.imgCount}`] = img.file
      })
    },
    setImage (e) {
      if (this.enableUpload) {
        const file = e.target.files[0]
        this.images.push({
          preview: URL.createObjectURL(file),
          filename: file.name,
          file: file
        })
      }
      this.setImageParam()
    },
    removeImage (idx) {
      this.images.splice(idx, 1)
      _.each(['one', 'two', 'three'], key => {
        delete this.params[`installation_picture_${key}`]
      })
      this.setImageParam()
    },
    submit () {
      this.loading = true
      const formData = new FormData()

      for (let key in this.params) {
        let value = this.params[key]
        formData.append(`support_request[${key}]`, value)
      }
      this.$http.post('/clients/' + this.currentClient.id + '/support_requests', formData, {
        headers: {
          ...this.clientAuth,
          'Content-Type': 'multipart/form-data'
        }
      }).then(resp => {
        this.$store.dispatch('fetchProductRegistrations').then(() => {
          this.loading = false
          this.$router.push({ name: 'supportRequests' })
        })
      }).catch(err => {
        this.loading = false
        this.errors = {}
        if (err.response.status === 422) {
          let e = err.response.data
          this.errors = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
        }
      })
    }
  }
}
</script>
